import React from 'react';
import { Typography, FormControl } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

interface props {
  sx: any;
  name: string;
  value: any;
  onChange: (newValue: any) => void;
  onMonthChange?: (month: any) => void;
  minDate?:object;
  maxDate?:object;
  shouldDisableDate?: (day: Date) => boolean;
}

const CustomDatePicker: React.FC<props> = ({ sx, name, value, onChange, onMonthChange, minDate, maxDate, shouldDisableDate }) => {

  return (
    <FormControl sx={sx}>
      <Typography style={{fontSize:'15px'}}>{name}</Typography>
      <DatePicker
        sx={{ 
          mt: '2px', 
          borderRadius: '3px',
          boxShadow: '2px 2px 6px #b3b3b3', 
        }}
        value={value}
        onChange={onChange}
        onMonthChange={onMonthChange}
        defaultValue={dayjs(Date.now())}
        minDate={minDate}
        maxDate={maxDate}
        slotProps={{ 
          textField: { 
            // variant: 'standard',
          },
        }}
        shouldDisableDate={shouldDisableDate}
      />
    </FormControl>
  )
}

export default CustomDatePicker;
